import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24b85e75"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "content-wrapper d-flex" }
const _hoisted_4 = { class: "alert-container d-flex flex-column position-relative" }
const _hoisted_5 = { class: "alert-title" }
const _hoisted_6 = {
  key: 0,
  class: "alert-image"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "alert-content" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "mt-auto" }
const _hoisted_11 = { class: "d-flex justify-content-center" }
const _hoisted_12 = { class: "px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_WarningGray = _resolveComponent("WarningGray")!
  const _component_AsahiClose = _resolveComponent("AsahiClose")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "basic-modal-wrap",
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.done && _ctx.done(...args)))
  }, [
    _createElementVNode("div", {
      class: "t-modal",
      onClick: _withModifiers(() => { }, ["stop"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_AsahiTypography, {
                type: "headline-1 font-open-sans",
                color: "",
                class: "bold"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.content?.title), 1)
                ]),
                _: 1
              }),
              (_ctx.content.warningSign === 'true')
                ? (_openBlock(), _createBlock(_component_WarningGray, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            (_ctx.content?.mandatory !== 'true')
              ? (_openBlock(), _createBlock(_component_AsahiClose, {
                  key: 0,
                  class: "close-btn clickable",
                  onClick: _ctx.done
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(`alignment-${_ctx.content.imageposition}`)
            }, [
              (_ctx.content?.image?.link)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("img", {
                      src: _ctx.content?.image?.link,
                      alt: ""
                    }, null, 8, _hoisted_7)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_AsahiTypography, {
                  type: "title-1-regular",
                  color: "tertiary-dark-gray",
                  class: "w-100 break-word"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
                      ref: "htmlContainer",
                      innerHTML: _ctx.content?.body
                    }, null, 8, _hoisted_9)
                  ]),
                  _: 1
                })
              ])
            ], 2),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_AsahiButton, {
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.content?.mandatory !== 'true' ? _ctx.done() : _ctx.confirm()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.content?.buttonLabel), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ], 8, _hoisted_1)
  ]))
}